import { IconButton, Tooltip } from "@mui/material";
import { MainCard, MuiTable, StatusTag } from "components";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { scrollToTop } from "Utils";
import {
  fetchTopics,
  changePage,
  changePageSize,
} from "../../../../redux/actions/topicsActions";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

const ListView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get data from Redux store
  const { data, loading, totalItems, filters } = useSelector(
    (state) => state.topics
  );

  // Load topics if not already loaded
  useEffect(() => {
    if (data.length === 0 && !loading) {
      dispatch(fetchTopics());
    }
  }, [dispatch, data.length, loading]);

  const setPage = (page) => {
    dispatch(changePage(page));
    scrollToTop();
  };

  const setPageSize = (pageSize) => {
    dispatch(changePageSize(pageSize));
    scrollToTop();
  };

  return (
    <div>
      <MainCard>
        <div>
          <MuiTable
            columns={[
              {
                accessorKey: "actions",
                header: t("topics.actions"),
                Cell: ({ cell }) => (
                  <div>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                          navigate(`/single_topic/${cell.row.original.id}`);
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ),
              },
              {
                accessorKey: "topic_name",
                header: t("topics.topic"),
              },
              {
                accessorKey: "category.category_name",
                header: t("topics.category"),
              },
              {
                accessorKey: "is_current_user_contribute",
                header: t("topics.contributionStatus"),
                Cell: ({ cell }) => {
                  const is_current_user_contribute = cell.getValue();
                  return (
                    <StatusTag
                      status={
                        is_current_user_contribute ? "Contributed" : "Pending"
                      }
                      variant="small"
                    />
                  );
                },
              },
              {
                accessorKey: "status",
                header: t("topics.status"),
                Cell: ({ cell }) => {
                  const status = cell.getValue();
                  return (
                    <StatusTag status={status.toLowerCase()} variant="small" />
                  );
                },
              },
            ]}
            data={data}
            title="DLIs"
            manualPagination={true}
            rowCount={totalItems}
            currentPage={filters.page}
            pageSize={filters.limit}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
            loading={loading}
          />
        </div>
      </MainCard>
    </div>
  );
};

export default ListView;
